import type { AxiosInstance } from "axios";
import { apiClient } from "@/marketing/infrastructure/http/httpClient";
import type { SkinSeoulProduct } from "@/marketing/models/product";

const BASE_PATH = "/products";

export class ProductAPIClient {
  constructor(private readonly client: AxiosInstance = apiClient) {}

  public async getProductsBySkus(skus: string[]): Promise<SkinSeoulProduct[]> {
    if (skus.length === 0) return [];

    const { data } = await this.client.get<SkinSeoulProduct[]>(BASE_PATH, {
      params: { skus: skus.join(",") },
    });
    return data;
  }
}

export const productAPIClient = new ProductAPIClient();
